const Classrooms = () => import("./views/Classrooms.vue");
const ClassroomEdit = () => import("./views/ClassroomEdit.vue");

const route = "/classrooms";

export default [
  {
    path: route,
    name: "classrooms.list",
    component: Classrooms,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "classrooms.create",
    component: ClassroomEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:classroomId/edit`,
    name: "classrooms.edit",
    component: ClassroomEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
